import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "q-gutter-xs"
}

import { format, useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import Router from "src/router"
import { useDevtoolsStore } from "src/stores/devtoolsStore"
import { Log } from "src/util/classes/log"
import { confirmationDialog } from "src/util/functions/dialogs"
import { ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogConnectVueDevtools',
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {



//endregion

//region Variables

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const { t } = useI18n()

const devtoolsStore = useDevtoolsStore()

const host = ref<string>(devtoolsStore.devToolsHost)
const port = ref<number>(devtoolsStore.devToolsPort)

//endregion

//region Functions

function reset() {
  // Set default values for connection
  // These parameters are what is used when calling devtools.connect() without arguments
  host.value = "localhost"
  port.value = 8098
}

function reload() {
  // router
  devtoolsStore.$reset()
  Router.go(0)
}

async function confirm() {
  const dialogResult = await confirmationDialog({
    title: t("sfxDialogConnectVueDevtools.prompt_sure"),
    content: t("sfxDialogConnectVueDevtools.devtools_terms"),
    html: true,
  })

  if (dialogResult) {
    try {
      devtoolsStore.configureDevtools(host.value, port.value)
      devtoolsStore.connectDevtools()
    } catch (error) {
      Log.error({ message: "Failed to connect to devtools.", error })
    } finally {
      onDialogOK()
    }
  }
}

function cancel() {
  onDialogCancel()
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide),
    position: "top",
    "transition-show": "slide-down",
    "transition-hide": "slide-up"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title text-h5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogConnectVueDevtools.title_devtools")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_form, {
            onSubmit: confirm,
            onReset: reset
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  (_unref(devtoolsStore).devToolsInitiated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("sfxDialogConnectVueDevtools.devtools_already_initiated")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createTextVNode(_toDisplayString(_ctx.$t("sfxDialogConnectVueDevtools.devtools_instructions")) + " ", 1),
                        _createVNode(SfxInput, {
                          modelValue: host.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((host).value = $event)),
                          label: _unref(format).capitalize(_ctx.$t('sfxDialogConnectVueDevtools.host')),
                          required: "",
                          "error-message": _ctx.$t('sfxDialogConnectVueDevtools.invalid_input')
                        }, null, 8, ["modelValue", "label", "error-message"]),
                        _createVNode(SfxInput, {
                          modelValue: port.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((port).value = $event)),
                          modelModifiers: { number: true },
                          label: _unref(format).capitalize(_ctx.$t('sfxDialogConnectVueDevtools.port')),
                          type: "number",
                          min: "1",
                          max: "65535",
                          required: "",
                          "error-message": _ctx.$t('sfxDialogConnectVueDevtools.invalid_input')
                        }, null, 8, ["modelValue", "label", "error-message"])
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(SfxBtnOutline, {
                    onClick: cancel,
                    label: _unref(format).capitalize(_ctx.$t('sfxButtons.btn_cancel')),
                    class: "col-grow"
                  }, null, 8, ["label"]),
                  (_unref(devtoolsStore).devToolsInitiated)
                    ? (_openBlock(), _createBlock(SfxBtn, {
                        key: 0,
                        onClick: reload,
                        label: _ctx.$t('sfxButtons.btn_reload_app'),
                        color: "warning",
                        class: "col-grow"
                      }, null, 8, ["label"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(SfxBtnOutline, {
                          type: "reset",
                          label: _unref(format).capitalize(_ctx.$t('sfxButtons.btn_reset')),
                          class: "col-grow"
                        }, null, 8, ["label"]),
                        _createVNode(SfxBtn, {
                          type: "submit",
                          label: _unref(format).capitalize(_ctx.$t('sfxButtons.btn_connect')),
                          class: "col-grow"
                        }, null, 8, ["label"])
                      ], 64))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})